// extracted by mini-css-extract-plugin
export var container = "_on-0";
export var dotAnimation = "_on-2";
export var dotsLoading = "_on-1";